import { FC, FocusEventHandler, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex, Form } from 'antd';
import { FormikErrors, FormikTouched } from 'formik';

import PlusIcon from 'assets/images/icons/plus.svg?react';
import { IArbitrageForm, useSourceSlice } from 'entities/Source';
import { IBadRequestData } from 'shared/typings';
import { InputUrl } from 'shared/ui';

interface IArbitrationUrlFormProps extends HTMLAttributes<HTMLDivElement> {
	values: IArbitrageForm;
	handleChange: (e: React.ChangeEvent<unknown>) => void;
	handleBlur: FocusEventHandler<HTMLInputElement>;
	errors: FormikErrors<IArbitrageForm>;
	touched: FormikTouched<IArbitrageForm>;
	apiErrors?: { url: (IBadRequestData | string)[] }[];
}

export const ArbitrationUrlForm: FC<IArbitrationUrlFormProps> = ({
	values,
	handleChange,
	handleBlur,
	errors,
	touched,
	apiErrors,
	...props
}) => {
	const { t } = useTranslation();
	const { arbitrationValues, setArbitrationValues } = useSourceSlice();

	return (
		<Flex {...props} vertical align="start" gap={8}>
			{arbitrationValues.urls.map((key, i) => {
				return (
					<Form.Item
						style={{ width: '100%' }}
						key={key}
						layout="vertical"
						label={i === 0 ? `${t('URL Рекламной сети')} (${t('Макс.')} 5)` : undefined}
						tooltip={t(
							'Укажите, где покупается трафик и выберите один, который по умолчанию будет показываться Брендам.',
						)}
						required={i === 0}
						validateStatus={errors?.[`url${key}`] && touched?.[`url${key}`] ? 'error' : ''}
						help={errors?.[`url${key}`] && touched?.[`url${key}`] && errors?.[`url${key}`]}>
						<InputUrl
							name={`url${key}`}
							placeholder={t('Укажите URL')}
							value={values[`url${key as '1'}`]}
							onChange={(e) => {
								setArbitrationValues({ ...arbitrationValues, [`url${key as '1'}`]: e.target.value });
								handleChange(e);
							}}
							onBlur={handleBlur}
							allowClear
							errors={typeof Number(key) === 'number' ? apiErrors?.[Number(key) - 1]?.url : undefined}
						/>
					</Form.Item>
				);
			})}

			{arbitrationValues.urls.length < 5 && (
				<Button
					variant="text"
					color="primary"
					icon={<PlusIcon width={16} height={16} />}
					onClick={() =>
						setArbitrationValues({
							...arbitrationValues,
							urls: [...arbitrationValues.urls, (arbitrationValues.urls.length + 1 + '') as '1'],
						})
					}>
					{t('Добавить URL')}
				</Button>
			)}
		</Flex>
	);
};
